import React from 'react'
import PropTypes from 'prop-types'
import useFetching from 'hooks/useFetching'
// import Loader from 'navigation/components/Loader'
import ErrorMessage from './ErrorMessage'

const Query = React.memo(({ url, options, children, error: errorRender, noRenderOnError }) => {
  const { response, 
    // loading, 
    error } = useFetching(url, options)
  
  // if (loading) return <Loader />
  if (error) {
    if (noRenderOnError) return null
    return errorRender || <ErrorMessage message={error.message} />
  }
  if (response && response.data) return children(response)
  return ''
})

Query.propTypes = {
  noRenderOnError: PropTypes.bool
}

Query.defaultProps  = {
  noRenderOnError: false
}



export default Query
